class WishlistButton extends HTMLElement {
    constructor() {
      super();
  
      this.button = this.querySelector("button");
      this.formId = this.dataset.formId;
      this.productId = this.dataset.productId;
      this.productTitle = this.dataset.productTitle;
      this.productUrl = this.dataset.productUrl;
      this.imageUrl = this.dataset.imageUrl;
  
      this.clickHandler = this.onClick.bind(this);
  
      if ('_swat' in window) {
        this.init(window._swat);
      } else {
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push(this.init.bind(this));
      }
    }
  
    async init(swat) {
      this.button.classList.remove("loading");
      const wishlist = await new Promise((resolve) => {
        swat.fetch(resolve);
      });
      const isAdded = wishlist.some(({ empi }) => empi === Number(this.productId));
  
      if (isAdded) {
        this.button.classList.add("added");
      } else {
        this.button.removeAttribute('disabled');
        this.button.setAttribute("aria-disabled", "false");
        this.button.addEventListener("click", this.clickHandler);
      }
    }
  
    async onClick(event) {
      event.preventDefault();
  
      const form = document.querySelector(`[id='${this.formId}']`);
  
      document.querySelectorAll(`[id='${this.formId}'], [form='${this.formId}']`).forEach((element) => {
        element.classList.add('submitted');
      });
  
      form.classList.add('submitted');
      
      const formData = new FormData(form);
  
      const variantId = Number(formData.get('id'));
  
      if (variantId) {
        const response = await new Promise((resolve) =>
          window._swat.addToWishList({ ...this.buildConfig(variantId) }, resolve)
        );
  
        this.button.classList.add("added");
        this.button.removeEventListener("click", this.clickHandler);
      }
    }
  
    buildConfig(variantId) {
      const data = this.getVariantData();
      const variant = data.find(({ id }) => id === variantId);
  
      return {
        epi: variantId,
        empi: this.productId,
        du: this.productUrl,
        dt: this.productTitle,
        iu: this.imageUrl,
        pr: variant.price / 100,
        vi: variant.title,
      };
    }
  
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
}

customElements.define("wishlist-button", WishlistButton);